import {
  getSharedAssetContainerStyle,
  getSharedMultiSelectingCellStyles,
} from './shared-cell-style';

export const getImageAssetsGridCellStyle = (components, { palette = {} } = {}) => ({
  '@keyframes updatingSpin': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' },
  },

  imageAssetsGridCellContainer: {
    ...getSharedAssetContainerStyle(components, { palette }),

    // the 'Updating' label animation
    '& .updating-label-icon-and-text': {
      display: 'flex',
      background: palette.neutralPrimary,

      '& .label-icon': {
        animationName: '$updatingSpin',
        animationDuration: '1.5s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
      },
    },
  },

  imageCellLabelContainer: {
    display: 'flex',
    flexDirection: 'row',
    position: 'absolute',
    left: 12,
    bottom: 8,
    zIndex: 1,

    '& .created-with-ai-label': {
      display: 'flex',
      background: 'red',
      padding: 0,
      margin: 0,
      marginRight: 6,
      height: 24,
      backgroundColor: '#FFFFFFBB',

      '& .label-icon': {
        margin: 0,
      },
    },
  },

  // only show checkbox on overlay if it is NOT in multi-selecting mode
  ...getSharedMultiSelectingCellStyles(components, { palette }),

});
